/**
 * FormField - Reusable form input component
 * 
 * A standardized form field component that handles common input types with consistent styling,
 * accessibility features, and validation indicators. Main purpose is to reduce code duplication.
 * 
 * Supported types: text, textarea, checkbox, select
 * 
 * @example
 * <FormField
 *   id="title"
 *   label="Title"
 *   type="text"
 *   value={value}
 *   onChange={handleChange}
 *   required
 * />
 */export const FormField = ({ 
    id, 
    label, 
    description, 
    type = "text", 
    value, 
    onChange, 
    placeholder,
    rows,
    required = false,
    children
}) => (
    <div className="m-form-group">
        <label htmlFor={id} className="a-label">
            {label} {required && <span className="a-required">*</span>}
        </label>
        {description && (
            <p className="a-subtle-text a-muted-text">{description}</p>
        )}
        {type === "textarea" ? (
            <textarea
                id={id}
                className="a-textarea-input"
                rows={rows || 3}
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
            />
        ) : type === "checkbox" ? (
            <label className="a-checkbox">
                <span>{description}</span>
                <input
                    id={id}
                    type="checkbox"
                    checked={value}
                    onChange={onChange}
                />
                <div className="b-input"></div>
            </label>
        ) : type === "select" ? (
            <select 
                id={id}
                className="a-select-input"
                value={value || ''}
                onChange={onChange}
            >
                {placeholder && <option value="">{placeholder}</option>}
                {children}
            </select>
        ) : (
            <input
                id={id}
                type={type}
                className="a-text-input"
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
            />
        )}
    </div>
);